import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
//import Typography from '@mui/material/Typography';

//import NotificationsIcon from '@mui/icons-material/Notifications';
import TopSalesBox from './TopSalesBox';
import Title from './Title';
import useStyles from './Styles';

interface TopSalesProps {
    sales:any,
    months: string[],
}

const TopSales:React.FC<TopSalesProps> = (props)=> {
	const classes = useStyles();
	return (
        <Box style={{marginBottom:"4em"}}>
            <Title text="売上金額と個数"/>
            <Grid container spacing={2}>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="今月" date={props.months[0]} primary={props.sales.month0} secondary={props.sales.su_month0} primaryUnit="円" secondaryUnit="個"/>
                </Grid>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="先月" date={props.months[1]} primary={props.sales.month1} secondary={props.sales.su_month1} primaryUnit="円" secondaryUnit="個"/>
                </Grid>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="先々月" date={props.months[2]} primary={props.sales.month2} secondary={props.sales.su_month2} primaryUnit="円" secondaryUnit="個"/>
                </Grid>
                <Grid item xs={6} md={3}>
                    <TopSalesBox title="過去１年" primary={props.sales.year} secondary={props.sales.su_year} primaryUnit="円" secondaryUnit="個"/>
                </Grid>
            </Grid>
        </Box>
    );
}

export default TopSales;
